import accordionArrowImg from "../../../assets/images/svgicons/accordion-arrow.svg";
import { Button, Card, CardContent, CardHeader, CardTitle } from 'alm-react-components'
import SaveIcon from "../../../assets/images/svgicons/save.svg";
import UnsaveIcon from "../../../assets/images/svgicons/unsave.svg";
import { useNavigate } from 'react-router-dom';
import PlayIcon from "../../../assets/images/svgicons/play.svg";
import { useTranslation } from 'react-i18next';
import useLibrarySeeAll from "../../../hooks/useLibrarySeeAll";
import { defaultImage } from "../../../lib/utils";
import { APPROUTES, constants, DateFormat, Tag } from "../../../assets/constants/constants";
import getLocalizedContent from "../../../lib/getLocalizedMetaData";
import { useContext, useEffect, useLayoutEffect, useState } from "react";
import { apis } from "../../../services/alm";
import { getRecommendedContent } from "../../../services/ai";
import { AppContext } from "../../../context/AppProvider";
import withAlmToken from "../../common/withAlmToken";
import moment from "moment-timezone";
const RecommendedContent = () => {
    const {
        bookMarkresponse,
        deleteBookMark,
        addBookMark
    } = useLibrarySeeAll()
    const navigate = useNavigate()
    const { state, dispatch } = useContext(AppContext);

    const [isLoading, setIsLoading] = useState(false)
    const [isData, setIsData] = useState<any>([]);
    const [isRecommendedContent, setIsRecommendedData] = useState<any>([]);
    const { t } = useTranslation()

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        getData()
    }, [])
    const getData = () => {
        setIsLoading(true)
        getRecommendedContent(state?.user?.userId).then((res: any) => {
            const arr1 = res.slice(constants.OFFSET, constants.LP_PAGE_LIMIT)
            const arr2 = res.slice(constants.LP_PAGE_LIMIT, constants.SEE_MORE_LIMITS)
            const newArr = [arr1, arr2]
            setIsData(newArr)
        })
    }
    const fetchRecommendedContent = async (courses: any) => {
        const Apiresponse = await Promise.all(courses.map(async (item: any) => {
            let result: any = []
            if (item.length > 0) {
                result = await apis.getRecomendedContent(item)
            }
            return result?.data
        }))
        dispatch({
            type: "LIBRARY_DATA",
            payload: { ...state.libraryData, "Recommended": Apiresponse.flat(1).filter((res: any) => res !== undefined) },
        });
        setIsRecommendedData(Apiresponse.flat(1).filter((res: any) => res !== undefined))
    }
    useEffect(() => {
        if (isData.flat(1).length > 0) {
            fetchRecommendedContent(isData)
        }
    }, [bookMarkresponse, isData])

    return (
        <div>
            <div className="max-sm:pt-6 px-5 lg:px-8 xl:pr-32 xl:pl-32 md:py-14 w-[100%] md:px-8 mb-12">
                <div className="flex justify-between items-center pl-2 relative">
                    <Button
                        onClick={() => navigate(`/home/library`)}
                        variant="default"
                        className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0"
                    >
                        <img src={accordionArrowImg} alt={" "} className="logo cursor-pointer h-[14px] ml-4 rotate-180" />
                    </Button>
                </div>
                <h2 className="text-3xl font-barlowLight mt-6">
                <span dangerouslySetInnerHTML={{ __html: (t('Common.recommendedContent')) }} />{""} {state?.user?.fields?.displayName ? state?.user?.fields?.displayName : state?.user?.name}
                </h2>
                {isLoading && (
                    <>
                        <div className="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-x-6 gap-y-6 mt-12">
                            {isRecommendedContent?.length > 0 &&
                                isRecommendedContent?.map((res: any) => {
                                    const content = getLocalizedContent(res?.attributes?.localizedMetadata);
                                    const releaseDate = res?.attributes?.tags
                                        ?.filter((item: any) => item?.split(':')[0] === Tag.releaseDate)[0]
                                        ?.split(':')[1];
                                    return <>
                                        <Card onClick={() => navigate(`/home/library/library-course/${res?.id}`, { state: { courseType: constants.RECOMMENDED, filterationTag: constants.RECOMMENDED, from: APPROUTES.recomendedContent } })} className="w-full h-full p-0 bg-fillMidGrayCard cursor-pointer border-cardBorder relative rounded-lg">
                                            <CardHeader className="p-0">
                                                <div
                                                    className={`relative cursor-pointer`}
                                                >
                                                    {res?.attributes?.imageUrl ? (
                                                        <img
                                                            src={res?.attributes?.imageUrl}
                                                            alt={" "}
                                                            className="rounded-t-lg w-full h-full aspect-[3/2] object-cover"
                                                        />
                                                    ) : (
                                                        <img
                                                            src={defaultImage()}
                                                            alt={" "}
                                                            className="rounded-t-lg w-full h-full aspect-[3/2] object-cover"
                                                        />
                                                    )}
                                                    <img

                                                        src={PlayIcon}
                                                        alt={" "}
                                                        className="absolute center-icon"
                                                    />
                                                </div>
                                            </CardHeader>
                                            <CardContent className="mt-4 px-5">
                                                <div className="flex flex-row items-start justify-between mt-2 h-full break-words">
                                                    <div className="flex flex-col justify-between">
                                                        <div className="flex flex-col">
                                                            <CardTitle className="text-wrap text-2xl font-barlowLight tracking-normal font-normal">
                                                                {content?.name}
                                                            </CardTitle>
                                                            <p className="text-lg font-opensansRegular mt-2 mb-16 flex-grow">
                                                                {content?.description}
                                                            </p>
                                                        </div>
                                                        <p className="text-base font-opensansMedium absolute bottom-6">
                                                            {/* {formatDate(
                                                                releaseDate ? releaseDate : ""
                                                            )} */}
                                                            <span className="capitalize">
                                                            {releaseDate && moment(releaseDate).isValid() ? moment(releaseDate).format(DateFormat) : ""}
                                                            </span>   
                                                        </p>
                                                    </div>
                                                    <img
                                                        onClick={(e) => { e.stopPropagation(); res.attributes?.isBookmarked ? deleteBookMark(res?.id) : addBookMark(res?.id) }}
                                                        src={res?.attributes?.isBookmarked ? SaveIcon : UnsaveIcon}
                                                        alt="No image"
                                                        className="ms-5 cursor-pointer"
                                                    />
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </>
                                })
                            }
                        </div>
                    </>
                )}
            </div>
        </div>

    )
}

export default withAlmToken(RecommendedContent)